import React from "react";
import { Card } from "ui/components/card";
import { EvtHeader } from "components/header";
import { EvtStatsCard } from "components/stats/display-card";
import { AVAILABLE_HOUR_INFO } from "../constant";
import { formatHoursToTime } from "utils/timesheet";
import { EvtStatsCardPlaceholder } from "components/stats/placeholder";

export function HoursOverview({ data, isLoading, error }) {

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-5 gap-4 px-6 m-6">
        <EvtStatsCardPlaceholder className="w-[300px]" />
      </div>
    );
  }

  if (error) {
    return <div className="p-6 text-red-500">Failed to load overview</div>;
  }

  if (!data) {
    return <div className="p-6">No data available</div>;
  }

  const { available_hours, logged_hours, draft_hours, approved_hours, free_hours } = data;

  return (
    <Card className="border-none shadow-none">
      <EvtHeader title="Hours Overview" />
      <div className="grid grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-5 gap-4 px-6">
        <EvtStatsCard
          label="Available Hours"
          value={formatHoursToTime(available_hours.hours)}
          info={AVAILABLE_HOUR_INFO}
        />
        <EvtStatsCard
          label="Logged Hours"
          value={formatHoursToTime(logged_hours.hours)}
          description={`${logged_hours.percentage ?? 0}%`}
        />
        <EvtStatsCard
          label="Approved Hours"
          value={formatHoursToTime(approved_hours.hours)}
          description={`${approved_hours.percentage ?? 0}%`}
        />
        <EvtStatsCard
          label="Free Hours"
          value={formatHoursToTime(free_hours.hours)}
          description={`${free_hours.free_hours_percentage ?? 0}%`}
        />
      </div>
    </Card>
  );
}
